// extracted by mini-css-extract-plugin
export default {"chatList":"chat_chatList__xmq12","newChatTitle":"chat_newChatTitle__1rr1t"};